<template>
    <div>
        <v-btn v-for="button in buttonsOptions"
               :class="classBtn(button)"
               :style="`height: ${height}px !important`"
               @click="currentGroupBy = button.value"
               depressed>
            {{ button.name }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "GroupBySelector",
    props: {
        noMonthly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: 'daily',
        },
        items: {
            type: Array,
            default: null,
        },
        height: {
            type: [String, Number],
            default: undefined
        },
        rounded: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            currentGroupBy: 'daily',
        }
    },
    computed: {
        buttons(vm = this) {
            if (vm.noMonthly) {
                return [
                    {name: vm.$t('statistics.weekly'), value: 'weekly'},
                    {name: vm.$t('statistics.daily'), value: 'daily'},
                ]
            }
            return [
                {name: vm.$t('statistics.monthly'), value: 'monthly'},
                {name: vm.$t('statistics.weekly'), value: 'weekly'},
                {name: vm.$t('statistics.daily'), value: 'daily'},
            ]
        },
        buttonsOptions(vm = this) {
            return vm.items ? vm.items : vm.buttons
        }
    },
    mounted() {
        const vm = this
        vm.setDefault()
    },
    methods: {
        setDefault() {
            const vm = this
            vm.currentGroupBy = vm.value
        },
        classBtn(button) {
            let className = button.value === this.currentGroupBy ? 'mr-1 b-small-primary' : 'mr-1 b-small-grey'
            let rounded = this.rounded ? 'rounded' : ''
            return rounded + ' ' + className
        }
    },
    watch: {
        currentGroupBy(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefault()
        }
    }
}
</script>

<style scoped>

.rounded {
    border-radius: 16px !important;
}

</style>